<template>
  <RelatorioParcelasRecebidasFiltro @export="exportReport" />
</template>
<script>
import RelatorioParcelasRecebidasFiltro from './components/parcelasRecebidasFiltro.vue';

import reportsApi from '../../../../services/reports.api';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';

export default {
  name: 'RelatorioParcelasRecebidas',
  components: {
    RelatorioParcelasRecebidasFiltro,
  },
  methods: {
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportReceivedInstallmentReport(
          filters,
        );
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Parcelas Recebidas - ${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao gerar o relatório de parcelas recebidas',
        );
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
